"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Condition = void 0;
var matcher_1 = require("./matcher");
var properties_maker_1 = require("../util/properties-maker");
var advanced_logic_error_1 = require("../util/advanced-logic-error");
var uuid_1 = require("uuid");
var Condition = /** @class */ (function () {
    function Condition(arg) {
        this.validateConstructorArg(arg);
        this.id = arg.id || uuid_1.v1();
        this.matcher = arg.matcher;
        this.value = arg.value;
        this.context = arg.context;
    }
    // move to builder
    Condition.prototype.validateConstructorArg = function (arg) {
        var prefix = 'Condition creation: ';
        if (arg.matcher && !Object.values(matcher_1.Matcher).includes(arg.matcher)) {
            throw new advanced_logic_error_1.AdvancedLogicError(prefix + ' matcher is not valid.');
        }
    };
    Condition.buildFrom = function (src, props) {
        return new Condition(properties_maker_1.PropertiesMaker.merge(src, props));
    };
    return Condition;
}());
exports.Condition = Condition;
